<div class="rank-container">
  <div class="rank-content" *ngIf="!isLoading; else loading">
    <div class="podium-section" *ngIf="users.length >= 3">
      <div class="podium-container">
        <div
          class="podium-player second-place"
          (click)="goToProfile(users[1].id)"
        >
          <div class="podium-rank">2</div>
          <div class="podium-avatar">
            <img
              [src]="
                users[1].profile_image || '../../assets/images/profile-pic.png'
              "
              alt=""
            />
          </div>
          <div class="podium-name">
            {{ users[1].name }} {{ users[1].last_name }}
          </div>
          <div class="podium-points">{{ users[1].pp_points }} pts</div>
        </div>

        <div
          class="podium-player first-place"
          (click)="goToProfile(users[0].id)"
        >
          <div class="podium-crown">
            <lucide-icon name="crown" [size]="24" color="#f59e0b"></lucide-icon>
          </div>
          <div class="podium-rank">1</div>
          <div class="podium-avatar">
            <img
              [src]="
                users[0].profile_image || '../../assets/images/profile-pic.png'
              "
              alt=""
            />
          </div>
          <div class="podium-name">
            {{ users[0].name }} {{ users[0].last_name }}
          </div>
          <div class="podium-points">{{ users[0].pp_points }} pts</div>
        </div>

        <div
          class="podium-player third-place"
          (click)="goToProfile(users[2].id)"
        >
          <div class="podium-rank">3</div>
          <div class="podium-avatar">
            <img
              [src]="
                users[2].profile_image || '../../assets/images/profile-pic.png'
              "
              alt=""
            />
          </div>
          <div class="podium-name">
            {{ users[2].name }} {{ users[2].last_name }}
          </div>
          <div class="podium-points">{{ users[2].pp_points }} pts</div>
        </div>
      </div>
    </div>

    <div class="rankings-section">
      <h2 class="section-title">All Rankings</h2>
      <div class="rankings-list">
        <div
          *ngFor="let user of users; let i = index"
          class="rank-card"
          [class.top-three]="i < 3"
          [class.current-user]="isCurrentUser(user.id)"
          (click)="goToProfile(user.id)"
        >
          <div class="rank-position">
            <span class="rank-number" [class.medal]="i < 3">
              <span *ngIf="i === 0" class="medal-icon gold"
                ><lucide-icon
                  name="crown"
                  [size]="20"
                  color="#f59e0b"
                ></lucide-icon
              ></span>
              <span *ngIf="i === 1" class="medal-icon silver"
                ><lucide-icon
                  name="medal"
                  [size]="20"
                  color="#94a3b8"
                ></lucide-icon
              ></span>
              <span *ngIf="i === 2" class="medal-icon bronze"
                ><lucide-icon
                  name="award"
                  [size]="20"
                  color="#d97706"
                ></lucide-icon
              ></span>
              <span *ngIf="i >= 3">{{ user.rank }}</span>
            </span>
          </div>

          <div class="player-info">
            <div class="player-avatar">
              <img
                [src]="
                  user.profile_image || '../../assets/images/profile-pic.png'
                "
                alt=""
              />
            </div>
            <div class="player-details">
              <div class="player-name">
                {{ user.name }} {{ user.last_name }}
              </div>
              <div class="player-stats">
                <span class="stat-item">{{ user.wins || 0 }}W</span>
                <span class="stat-item">{{ user.loses || 0 }}L</span>
                <span class="stat-item" *ngIf="getWinRate(user) !== null"
                  >{{ getWinRate(user) }}%</span
                >
              </div>
            </div>
          </div>

          <div class="rank-points">
            <div class="points-value">{{ user.pp_points || 0 }}</div>
            <div class="points-label">points</div>
          </div>

          <div class="rank-arrow">›</div>
        </div>
      </div>
    </div>
  </div>

  <ng-template #loading>
    <div class="loading-container">
      <div class="loading-spinner"></div>
      <p class="loading-text">Loading rankings...</p>
    </div>
  </ng-template>
</div>
